import { create } from "zustand";
import instance from "@/lib/axios";
import { useOrganizationStore } from "@/stores/useOrganizationStore";
import type { OrgSettings } from "@/types/organization/settings";

interface OrgSettingsState {
  settings: OrgSettings | null;
  fetchedOrgSlug: string | null;
  isLoading: boolean;
  fetchSettings: () => Promise<void>;
  clearOrgSettingsStore: () => void;
}

export const useOrgSettingsStore = create<OrgSettingsState>()((set, get) => ({
  settings: null,
  fetchedOrgSlug: null,
  isLoading: false,

  fetchSettings: async () => {
    if (get().isLoading) return;
    let orgSlug = useOrganizationStore.getState().orgSlug;
    if (!orgSlug) {
      await useOrganizationStore.getState().fetchOrgSlug();
      orgSlug = useOrganizationStore.getState().orgSlug;
    }
    if (!orgSlug) return;
    // `fetchedOrgSlug` marks the attempt, not the success — see useFeatureStore.
    if (get().fetchedOrgSlug === orgSlug) return;
    set({ isLoading: true });
    try {
      const { data } = await instance.get<OrgSettings>(
        `/api/${orgSlug}/organization/settings/`,
      );
      set({ settings: data, fetchedOrgSlug: orgSlug, isLoading: false });
    } catch {
      set({ fetchedOrgSlug: orgSlug, isLoading: false });
    }
  },

  clearOrgSettingsStore: () => {
    set({ settings: null, fetchedOrgSlug: null });
  },
}));
